var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutionCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24.4813 19.0094",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.37437 18.6431C9.14062 18.8781 8.82188 19.0094 8.49063 19.0094C8.15938 19.0094 7.84063 18.8781 7.60688 18.6431L0.549375 11.5844C-0.183125 10.8519 -0.183125 9.66437 0.549375 8.93312L1.43312 8.04937C2.16563 7.31687 3.35187 7.31687 4.08437 8.04937L8.49063 12.4556L20.3969 0.549375C21.1294 -0.183125 22.3169 -0.183125 23.0481 0.549375L23.9319 1.43313C24.6644 2.16563 24.6644 3.35313 23.9319 4.08438L9.37437 18.6431Z",
    fill: "var(--fill-0, #464646)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionCheck);
export default __webpack_public_path__ + "static/media/execution-check.30b95b107b376f90aa6524e5c46eb122.svg";
export { ForwardRef as ReactComponent };